import { Box, Modal } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#f5f5f5'
    },
    headerControls: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px',
      backgroundColor: 'white',
      borderBottom: '1px solid #ddd',
      flexWrap: 'wrap',
      gap: '10px'
    },
    navigationGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    navButton: {
      padding: '8px 12px',
      backgroundColor: '#f0f0f0',
      border: '1px solid #ccc',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '14px'
    },
    weekTitle: {
      margin: '0',
      fontSize: '18px',
      fontWeight: 'bold'
    },
    intervalControls: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    intervalSelect: {
      padding: '6px 10px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      fontSize: '14px'
    },
    weekViewHeaderContainer: {
      display: 'flex',
      backgroundColor: 'white',
      borderBottom: '2px solid #ddd',
      height:'auto'
    },
    weekTimeHeader: {
      width: '80px',
      height: '60px',
      backgroundColor: '#f8f9fa',
      borderRight: '1px solid #ddd',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      fontWeight: 'bold'
    },
    weekViewHeader: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 1fr)',
      flex: 1
    },
    dayHeader: {
      padding: '10px',
      fontWeight: 'bold',
      fontSize: '14px',
      textAlign: 'center',
      borderRight: '1px solid #ddd',
      backgroundColor: '#f8f9fa'
    },
    weekScrollableContainer: {
      flex: 1,
      overflow: 'auto',
      backgroundColor: 'white',
      // Ensure proper scrolling behavior
      overflowY: 'scroll',
      // Add some bottom padding to ensure last items are visible
      paddingBottom: '20px',
      // Hide scrollbar for different browsers
      scrollbarWidth: 'none', // Firefox
      msOverflowStyle: 'none', // Internet Explorer and Edge
      '&::-webkit-scrollbar': {
        display: 'none' // Chrome, Safari, Opera
      }
    },
    weekViewGrid: {
      display: 'flex',
      flexDirection: 'column',
      // Ensure minimum height so all time slots are rendered
      minHeight: 'fit-content'
    },
    weekHourRow: {
      display: 'grid',
      gridTemplateColumns: '80px repeat(7, 1fr)',
      // Fixed: Uncomment and set proper height based on time interval
      height: '60px', // Default height - you can make this dynamic based on timeInterval
      minHeight: '40px', // Minimum height to ensure visibility
      borderBottom: '1px solid #eee'
    },
    weekTimeCell: {
      backgroundColor: '#f8f9fa',
      borderRight: '1px solid #ddd',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '11px',
      color: '#666',
      padding: '4px'
    },
    weekDayCell: {
      borderRight: '1px solid #ddd',
      position: 'relative',
      padding: '2px',
      backgroundColor: 'white',
      cursor: 'pointer',
      // Ensure proper height inheritance
      height: '100%',
      boxSizing: 'border-box'
    },
    appointmentContainer: {
      position: 'absolute',
      top: '2px',
      left: '2px',
      right: '2px',
      backgroundColor: '#4285f4',
      borderRadius: '4px',
      cursor: 'pointer',
      zIndex: 1,
      minHeight: '24px'
    },
    appointmentLabel: {
      color: 'white',
      padding: '4px 6px',
      fontSize: '10px',
      lineHeight: '1.2'
    },
    clockInButton: {
      backgroundColor: 'rgba(255,255,255,0.2)',
      color: 'white',
      border: '1px solid rgba(255,255,255,0.3)',
      borderRadius: '3px',
      padding: '2px 6px',
      fontSize: '9px',
      cursor: 'pointer',
      marginTop: '2px'
    },
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    },
    modalContent: {
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      minWidth: '300px',
      maxWidth: '500px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
    },
    modalButton: {
      padding: '8px 16px',
      borderRadius: '4px',
      cursor: 'pointer',
      marginRight: '10px'
    },
    primaryButton: {
      backgroundColor: '#4285f4',
      color: 'white',
      border: 'none'
    },
    secondaryButton: {
      backgroundColor: '#f0f0f0',
      color: '#333',
      border: '1px solid #ccc'
    }
  };

// function WeekView({ currentDate, appointments }) {
function WeekView({currentDate, setCurrentDate, appointments, setSelectedSlot, setShowAppointmentPanel }) {
  const [timeInterval, setTimeInterval] = useState(60);
  const [activeAppointment, setActiveAppointment] = useState(null);

const generateTimeSlots = (intervalMinutes) => {
  const slots = [];
  const totalMinutes = 24 * 60; // 1440 minutes in a day
  
  // Changed condition to include the final slots
  for (let i = 0; i <= totalMinutes; i += intervalMinutes) {
    // Handle the case where we go past midnight
    const hours = Math.floor(i / 60) % 24;
    const minutes = i % 60;
    
    let displayHour = hours;
    let period = 'AM';
    
    if (hours === 0) {
      displayHour = 12;
    } else if (hours === 12) {
      period = 'PM';
    } else if (hours > 12) {
      displayHour = hours - 12;
      period = 'PM';
    }
    
    const timeString = intervalMinutes >= 60 
      ? `${displayHour} ${period}`
      : `${displayHour}:${minutes.toString().padStart(2, '0')} ${period}`;
    
    slots.push({
      value: i,
      display: timeString,
      hour: hours,
      minute: minutes,
      index: Math.floor(i / 60) 
    });
    
    // Stop if we've reached the end of the day
    if (i >= totalMinutes) break;
  }
  
  return slots;
};

  const timeSlots = generateTimeSlots(timeInterval);
  
  const getWeekDates = (date) => {
    const start = new Date(date);
    start.setDate(start.getDate() - start.getDay());
    return [...Array(7)].map((_, i) => {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      return d;
    });
  };

  const weekDates = getWeekDates(currentDate);

  const getAppointmentsForSlot = (dayIndex, slotIndex) => {
    const targetDate = weekDates[dayIndex];
    const slot = timeSlots[slotIndex] || timeSlots[Math.floor(slotIndex * (60 / timeInterval))];
    
    if (!slot) return [];

    return appointments?.filter((app) => {
      const appDate = new Date(app.date);
      const [startHour, startMinute = 0] = app.startTime?.split(":").map(Number) || [];
      
      const appStartMinutes = startHour * 60 + startMinute;
      
      return (
        appDate.getFullYear() === targetDate.getFullYear() &&
        appDate.getMonth() === targetDate.getMonth() &&
        appDate.getDate() === targetDate.getDate() &&
        appStartMinutes >= slot.value &&
        appStartMinutes < slot.value + timeInterval
      );
    });
  };


  return (
    <div className="week-view_CalendarView">
      <div style={styles.container}>
      {/* Header Controls */}
      {/* <div style={styles.headerControls}>
        <div style={styles.intervalControls}>
          <label style={{ fontWeight: 'bold' }}>Time Interval:</label>
          <select 
            value={timeInterval} 
            onChange={(e) => setTimeInterval(Number(e.target.value))}
            style={styles.intervalSelect}
          >
            <option value={5}>5 minutes</option>
            <option value={10}>10 minutes</option>
            <option value={15}>15 minutes</option>
            <option value={30}>30 minutes</option>
            <option value={60}>1 hour</option>
          </select>
        </div>
      </div> */}

      {/* Week View Header */}
      <div style={styles.weekViewHeaderContainer}>
        <div style={styles.weekTimeHeader}>
          Time
        </div>
        <div style={styles.weekViewHeader}>
          {weekDates.map((date, i) => (
            <div
              key={i}
              style={{
                ...styles.dayHeader,
                backgroundColor: date.toDateString() === new Date().toDateString() 
                  ? '#e3f2fd' 
                  : '#f8f9fa',
                borderRight: i < 6 ? '1px solid #ddd' : 'none'
              }}
            >
              {date.toLocaleDateString("en-US", {
                weekday: "short",
                month: "numeric",
                day: "numeric",
              })}
            </div>
          ))}
        </div>
      </div>

      {/* Scrollable Container */}
      <div style={styles.weekScrollableContainer}>
        <div style={styles.weekViewGrid}>
          {timeSlots.map((slot, slotIndex) => (
            <div key={slotIndex} style={styles.weekHourRow}>
              {/* Time Cell for this row */}
              <div style={styles.weekTimeCell}>
                {slot.display}
              </div>
              
              {weekDates.map((date, day) => {
                const appointmentsForSlot = getAppointmentsForSlot(day, slotIndex);

                return (
                  <div 
                    key={day} 
                    style={{
                      ...styles.weekDayCell,
                      borderRight: day < 6 ? '1px solid #ddd' : 'none'
                    }}
                    onClick={() => {
                        console.log("Selected Slot:", {
                          date: date.toDateString(),
                          time: slot.display,
                        });
                        setSelectedSlot({ date, slot });
                        setShowAppointmentPanel(true);
                      }}
                  >
                    {appointmentsForSlot.map((app, i) => (
                      <div
                        key={i}
                        style={styles.appointmentContainer}
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveAppointment(app);
                        }}
                      >
                        <div style={styles.appointmentLabel}>
                          <strong>Client:</strong> {app?.patientRequestId?.firstName}{" "}
                          {app?.patientRequestId?.lastName}
                          <br />
                          <strong>Provider:</strong> {app?.doctorRequestId?.firstName}{" "}
                          {app?.doctorRequestId?.lastName}
                          <br />
                          <div style={{ fontSize: '9px', marginTop: '2px' }}>
                            {app.startTime} - {app.endTime}
                          </div>
                          <button 
                            style={styles.clockInButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              console.log('Clock In clicked for:', app);
                            }}
                          >
                            Clock In
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

    </div>

      {/* MODAL */}
      {activeAppointment && (
        <div
          className="modal-overlay_week"
          onClick={() => setActiveAppointment(null)}
        >
          <div
            className="modal-content_week"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="tooltip-card">
              <div className="tooltip-header">
                <div className="tooltip-time">
                  {(() => {
                    if (
                      !activeAppointment.startTime ||
                      !activeAppointment.Duration
                    ) {
                      return activeAppointment.startTime || "N/A";
                    }

                    const start = moment(activeAppointment.startTime, "HH:mm");
                    const durationMinutes = parseInt(
                      activeAppointment.Duration
                    );
                    const end = start.clone().add(durationMinutes, "minutes");

                    return `${start.format("HH:mm")} - ${end.format("HH:mm")}`;
                  })()}
                </div>
                <div
                  className="tooltip-status"
                  style={{
                    backgroundColor:
                      activeAppointment?.appointmentStatus?.color,
                  }}
                >
                  {activeAppointment?.appointmentStatus?.name}
                </div>
              </div>

              <div className="tooltip-patient" style={{ textAlign: "left" }}>
                <strong>
                  {activeAppointment.patientRequestId?.firstName}{" "}
                  {activeAppointment.patientRequestId?.lastName}
                </strong>
                <div>DOB: {activeAppointment.dob || "N/A"}</div>
              </div>

              <hr />

              <div className="tooltip-section" style={{ textAlign: "left" }}>
                <h4>Visit Information</h4>
                <div className="margintop">
                  <strong className="details-width">Provider:</strong> Dr.{" "}
                  {activeAppointment.doctorRequestId?.firstName}{" "}
                  {activeAppointment.doctorRequestId?.lastName}
                </div>
                <div className="margintop">
                  <strong>Appointment Type:</strong>{" "}
                  {activeAppointment.deliveryMode?.name || "N/A"}
                </div>
                <div className="margintop">
                  <strong>Location:</strong>{" "}
                  {activeAppointment.serviceLocationId?.name || "N/A"}
                </div>
                <div className="margintop">
                  <strong>Visit Reason:</strong>{" "}
                  {activeAppointment.visitReason?.visitReason || "N/A"}
                </div>
                <div className="margintop">
                  <strong>Service Code(s):</strong>{" "}
                  {activeAppointment.visitReason?.cptCode || "N/A"}
                </div>
                <div className="patient-intake" style={{ marginTop: 10 }}>
                  <strong>Patient Intake:</strong>
                  <span> Pending </span>
                  <button style={{ color: "black" }}>Resend</button>
                </div>
                <div className="margintop">
                  <strong>Balance:</strong> $0.00
                </div>
              </div>

              <div className="tooltip-section" style={{ textAlign: "left" }}>
                <h4>Financial Information</h4>
                <div className="margintop">
                  <strong>Plan:</strong> BCBS FL HMO
                </div>
                <div className="margintop">
                  <strong>Effective:</strong> Not Specified
                </div>
                <div className="margintop">
                  <strong>Copay:</strong> $0.00
                </div>
                <div className="margintop">
                  <strong>Eligibility:</strong> Eligible for visit on 3/07/2025
                  <div className="tooltip-actions">
                    <a href="#">View Report</a>
                    <a href="#">Check Again</a>
                  </div>
                </div>
              </div>

              <div
                className="tooltip-footer"
                style={{ display: "flex", width: 80 }}
              >
                <button   onClick={() => setActiveAppointment(null)}> Close</button>
              </div>
              {/* <div className="tooltip-footer">
                <button style={{ color: "black" }}> Status</button>
                <button style={{ color: "black" }}>Create Note</button>
                <button style={{ color: "black" }}>Actions</button>
              </div> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default WeekView;
